export const SEARCH_TAGS = 'SEARCH_TAGS';
export const SEARCH_TAGS_SUCCESS = 'SEARCH_TAGS_SUCCESS';
export const CLEAR_TAGS = 'CLEAR_TAGS';



// WEBPACK FOOTER //
// ./src/actionTypes/tagActionTypes.js